import { useCartContext } from "../../context/CartContext";
import { NavLink, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import FormatPrice from "../../components/FormatPrice";

const CartPage = () => {
  const {
    cart,
    removeItem,
    clearCart,
    setDecrement,
    setIncrement,
    total_price,
    total_discount,
    paid_amount,
  } = useCartContext();

  if (cart.length === 0) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "500px" }}
      >
        <h1
          style={{
            border: "3px solid black",
            padding: "10px",
            borderRadius: "10px",
            fontWeight: "bold",
            color: "#0c0c0c",
          }}
        >
          Cart Is Empty
        </h1>
      </div>
    );
  }

  return (
    <>
      <section id="cart" className="section-p1">
        <h2
          style={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          CART
        </h2>

        <table width="10%" className="col-md-8">
          <thead>
            <tr>
              <td>Product</td>
              <td>Image</td>
              <td>Price</td>
              <td>Quantity</td>
              <td>Total</td>
              <td>Remove</td>
            </tr>
          </thead>

          <tbody>
            {cart.map((prod, index) => {
              return (
                <tr key={index}>
                  <td style={{ whiteSpace: "pre-line" }}>
                    <b>{prod.name}</b>
                  </td>

                  <td>
                    <img src={prod.image} alt="" />
                  </td>

                  <td>
                    <b>
                      <FormatPrice price={prod.price} />
                    </b>
                  </td>

                  <td>
                    <div className="quantity-control">
                      <button onClick={() => setDecrement(prod.id)}>-</button>
                      <p>{prod.amount}</p>
                      <button onClick={() => setIncrement(prod.id)}>+</button>
                    </div>
                  </td>

                  <td>
                    <b>
                      <FormatPrice price={Number(prod.price) * prod.amount} />
                    </b>
                  </td>

                  <td>
                    <Link onClick={() => removeItem(prod.id)}>
                      <i
                        className="fa fa-trash trashbtn"
                        aria-hidden="true"
                        style={{ fontSize: "25px", color: "red" }}
                      ></i>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>

      <div className="cart-two-button mt-5">
        <Button className="normalll ">
          Total Item{cart.length > 1 ? "s" : ""} : {cart.length}
        </Button>
        <NavLink to="/product">
          <Button className="normalll ">Continue Shopping</Button>
        </NavLink>
        <Button className="normalll " onClick={clearCart}>
          Clear Cart
        </Button>
      </div>

      <section id="cart-add" className="section-p1">
        <div id="coupon">
          {/* <h3>Apply Coupon</h3>
          <div>
            <input type="text" placeholder="Enter Your Coupon" />
            <button className="normal">Apply</button>
          </div> */}
        </div>

        <div id="subtotal">
          <h3>Cart Totals</h3>
          <table>
            <tbody>
              <tr>
                <td>Sub Total</td>
                <td>
                  <FormatPrice price={total_price} />
                </td>
              </tr>
              <tr>
                <td>Discount Amount</td>
                <td>
                  <FormatPrice price={total_discount} />
                </td>
              </tr>

              <tr>
                <td>Payable Amount</td>
                <td>
                  <FormatPrice price={total_price - total_discount} />
                </td>
              </tr>
              <tr>
                <td>Paid Amount</td>
                <td>
                  <FormatPrice price={paid_amount} />
                </td>
              </tr>
              <tr>
                <td>Due Amount</td>
                <td>
                  <FormatPrice
                    price={total_price - total_discount - paid_amount}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>
                    <FormatPrice
                      price={total_price - total_discount - paid_amount}
                    />
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>

          <Link
            style={{ textDecoration: "none", color: "white" }}
            to="/cart-checkout"
          >
            <button className="normal mt-2">Proceed to checkout</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default CartPage;
